import React from "react";
import { skillData, experience, startwork, longwork } from "./constdata";

const Userdetails = ({ data }) => {
  const getskillImg = (id) => {
    const index = skillData.findIndex((s) => s.id === id);
    return skillData[index];
  };

  const geteLabel = (id) => {
    const index = experience.findIndex((l) => l.value === id);
    return experience[index].label;
  };
  const getsLabel = (id) => {
    const index = startwork.findIndex((l) => l.value === id);
    return startwork[index].label;
  };
  const getlLabel = (id) => {
    const index = longwork.findIndex((l) => l.value === id);
    return longwork[index].label;
  };

  return (
    <>
      <section className="userDetailsSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="heading">
                <h4>Confirm your details</h4>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="details">
                <p className="head">Select Skill</p>
                {data.skill.includes(10) ? (
                  <p className="sub">{data.anotherSkill}</p>
                ) : (
                  <div className="row">
                    {data.skill.map((i, p) => (
                      <div
                        className="col-lg-2 col-md-2 col-sm-3 col-4 techImg mb-3"
                        key={p}
                      >
                        <div className="images">
                          <img
                            src={getskillImg(i).images}
                            className="img-fluid"
                            alt="Hire ReactJS Developers"
                          />
                          <span>{getskillImg(i).name}</span>
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-4 col-md-12 details">
                  <p className="head">Choose Experience</p>
                  <p className="sub">
                    {data.experience ? geteLabel(data.experience) : "---"}
                  </p>
                </div>
                <div className="col-lg-4 col-md-12 details details">
                  <p className="head">When to start?</p>
                  <p className="sub">
                    {data.startwork ? getsLabel(data.startwork) : "---"}
                  </p>
                </div>
                <div className="col-lg-4 col-md-12 details details">
                  <p className="head">Period of Hiring</p>
                  <p className="sub">
                    {data.longwork === "other"
                      ? data.skillname
                      : getlLabel(data.longwork)}
                  </p>
                </div>
              </div>
            </div>
            <div className="col-md-12">
              <div className="row">
                <div className="col-lg-4 col-md-12 details">
                  <p className="head">Your Name</p>
                  <p className="sub">
                    {data.userinfo.name ? data.userinfo.name : "---"}
                  </p>
                </div>
                <div className="col-lg-4 col-md-12 details">
                  <p className="head">Your Email ID</p>
                  <p className="sub">
                    {data.userinfo.email ? data.userinfo.email : "---"}
                  </p>
                </div>
                {data.userinfo.number ? (
                  <div className="col-lg-4 col-md-12 details">
                    <p className="head">Your Phone Number</p>
                    <p className="sub"> +{data.userinfo.number} </p>
                  </div>
                ) : null}
                {data.jobdescription.name ? (
                  <div className="col-lg-4 col-md-12 details">
                    <p className="head">Uploaded File</p>
                    <p className="sub"> {data.jobdescription.name} </p>
                  </div>
                ) : null}
                {data.jobdescription.requirements ? (
                  <div className="col-lg-8 col-md-12 details">
                    <p className="head">Your Requirements</p>
                    <p className="sub"> {data.jobdescription.requirements}</p>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Userdetails;
